import type { FaireProductEntity } from "../../entity_types/product";

export const p_vdu7gwva43: FaireProductEntity = {
  token: "p_vdu7gwva43",
  type: "product",
  name: "Hotan Jade Charm 18K Gold Plated S.Steel Necklace - FGS/CS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/74da9c4dec7f72773aa43c407dc8e71a0eb64cb198241c7fca5eff6d8b33af49.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af8db9561219bf6e08788dc222780d453e4a7e9ba06be657eaad2dbb7328178c.jpeg",
    "https://cdn.faire.com/fastly/c46633ecbf8aa7d5e6d807313c78b2f005bf04973ebedc8e5cea563785593220.jpeg",
    "https://cdn.faire.com/fastly/1258849d45db5e1c126037ccfc72c1c0a45a2646205b4a6298bc759e3a649708.jpeg",
  ],
  priceDollars: 5.92,
  description:
    "\nType: Pendant necklace\nMaterial: Stainless steel，Stone，18K gold plated\nSize of pendant : 11mm*12mm\nLength of chain : 415mm+50mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 14.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:27.306Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
